import { ListBase } from 'react-admin';
import { ExpensesClaimListLayout } from './ExpensesClaimListLayout';

export const ExpensesClaimList = () => {
    return (
        <ListBase
            resource="expensesClaim"
            perPage={25}
            sort={{ field: 'name', order: 'ASC' }}
        >
            <ExpensesClaimListLayout />
        </ListBase>
    );
};
